import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { formatDateShortMonth } from '@ami/react/core';
import { SearchQuoteResult as Quote } from './searchQuotes';
import { QuoteStatus } from '../otherQuoteEntities';

const Row = ({ quote }) => {
  return (
    <li className="row" key={quote.id}>
      <div className="col-md-4 col-6">
        <div>
          <Link to={`/quotes/view/${quote.id}`}>
            {quote.number} - {quote.name}
          </Link>
        </div>
        <div>
          {quote.make} {quote.model}
        </div>
      </div>
      <div className="col-md-4 col-6 text-center">
        <div>{quote.dealerBranch}</div>
        <div>{quote.dealerUser}</div>
      </div>
      <div className="col-md-4 col-6 text-end">
        <div>
          <strong>{quote.statusName}</strong>
        </div>
        {quote.poNumber && <div>PO {quote.poNumber}</div>}
        {(() => {
          switch (quote.status) {
            case QuoteStatus.Cancelled:
            case QuoteStatus.Expired:
            case QuoteStatus.Pending:
              return (
                <div className="created-on">
                  Created {formatDateShortMonth(quote.date)}
                </div>
              );
            case QuoteStatus.Accepted:
            case QuoteStatus.Completed:
              return (
                <div className="created-on">
                  PO submitted {formatDateShortMonth(quote.acceptedDate)}
                </div>
              );
            default:
              break;
          }
        })()}
      </div>
    </li>
  );
};

Row.propTypes = {
  quote: PropTypes.instanceOf(Quote).isRequired,
};

export default Row;
